import { motion } from "motion/react";
import type React from "react";
import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";

interface AnimatedCardProps {
	children: React.ReactNode;
	className?: string;
}

export const AnimatedCard: React.FC<AnimatedCardProps> = ({
	children,
	className,
}) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [height, setHeight] = useState<number | "auto">("auto");

	useEffect(() => {
		if (containerRef.current) {
			const resizeObserver = new ResizeObserver((entries) => {
				const observedHeight = entries[0].contentRect.height;
				setHeight(observedHeight);
			});

			resizeObserver.observe(containerRef.current);

			return () => {
				resizeObserver.disconnect();
			};
		}
	}, []);

	return (
		<motion.div
			animate={{ height }}
			className={cn(className, "overflow-hidden")}
			style={{ height }}
			transition={{ duration: 0.2, ease: "linear" }}
		>
			<div ref={containerRef}>{children}</div>
		</motion.div>
	);
};
